import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useStore } from "ra-core";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { AppSidebar } from "./AppSidebar";
import Header from "./Header";
import { SIDEBAR_COLLAPSED_STORE_KEY } from "./sidebarStore";

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  const [isSidebarCollapsed] = useStore<boolean>(
    SIDEBAR_COLLAPSED_STORE_KEY,
    false,
  );

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <AppSidebar />
      <div
        className={cn(
          "flex min-w-0 flex-1 flex-col overflow-hidden",
          isSidebarCollapsed ? "md:ml-0" : "",
        )}
      >
        <Header />
        <main
          className="min-h-0 flex-1 overflow-auto px-4 py-5 md:px-8"
          id="main-content"
        >
          <ErrorBoundary FallbackComponent={Error}>
            <Suspense
              fallback={<Skeleton className="h-12 w-12 rounded-full" />}
            >
              {children}
            </Suspense>
          </ErrorBoundary>
        </main>
      </div>
      <Notification />
    </div>
  );
};
